<template>
  <div class="container-fluid">
    <div class="row my-3">
      <div class="card w-100">
        <div class="card-header d-flex justify-content-between">
          <p>Байршилууд</p>
          <router-link
            v-if="!isBannerMgr"
            :to="{name: 'EntryCreate', params: {type: 4, parentId: parentId}}"
          >
            <button class="btn btn-primary">
              <i class="fas fa-plus"></i>
            </button>
          </router-link>
        </div>
        <div v-if="entries != null" class="card-body">
          <div class="article-card" v-for="(branch, i) in this.entries" :key="i">
            <div class="article-card__thumbnail">
              <img class="mh-100 mw-100" v-bind:src="branch.contents[0].thumb" alt>
            </div>
            <div class="article-card__details">
              <div class="d-flex flex-row flex-wrap">
                <h5 class="text-uppercase article-card__title">{{ branch.contents[0].title }}</h5>
                <div class="mx-2 map-url" v-if="getJsonData(branch.contents[0].description).mapUrl">
                  (
                  <a
                    v-bind:href="getJsonData(branch.contents[0].description).mapUrl"
                    target="_blank"
                  >Газрын зураг</a>)
                </div>
              </div>
              <p>
                <strong>Холбоо барих:</strong>
                {{ getJsonData(branch.contents[0].description).phone }}
              </p>
              <p>
                <strong>Цагийн хуваарь:</strong>
                {{ getJsonData(branch.contents[0].description).timeTable }}
              </p>
              <p>
                <strong>Хаяг:</strong>
                {{ getJsonData(branch.contents[0].description).address }}
              </p>
            </div>
            <div v-if="!isBannerMgr" class="article-card__actions">
              <router-link
                :to="{name: 'EntryEdit', params: {type: 4, entryId: branch.id, parentId: parentId}}"
              >
                <button class="btn btn-info btn-sm">
                  <i class="fas fa-edit"></i>
                </button>
              </router-link>
              <button
                v-if="!branch.staticFlag && branch.status == 1"
                class="btn btn-warning btn-sm mx-2 status-btn"
                @click="changeStatus(branch)"
              >
                <i class="fas fa-times"></i>
              </button>

              <button
                v-if="!branch.staticFlag && branch.status != 1"
                class="btn btn-success btn-sm mx-2 status-btn"
                @click="changeStatus(branch)"
              >
                <i class="fas fa-upload"></i>
              </button>
              <button @click="deleteBranch(branch.id)" class="btn btn-danger btn-sm">
                <i class="fas fa-trash"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-dialog/>
  </div>
</template>

<script>
import MenuService from "@/services/MenuService";
import DeleteDialog from "@/mixins/DeleteDialog.js";
import EntryList from "@/mixins/EntryList.js";

export default {
  name: "Branches",

  mixins: [DeleteDialog, EntryList],

  props: ["parentId", "entries"],

  methods: {
    deletedHandler(id) {
      let index = this.entries.map(entry => entry.id).indexOf(id);
      if (index > -1) this.entries.splice(index, 1);
    },

    deleteBranch(id) {
      this.confirmDelete(
        id,
        "Байршил устгах!",
        "Та энэ байршилыг устгах уу?",
        MenuService.changeStatus,
        this.deletedHandler
      );
    },

    getJsonData(desc) {
      let str = desc.replace(/\t/g, "\\t");
      return JSON.parse(str);
    }
  }
};
</script>